import { create } from 'zustand';
import type { Locale } from '../data/types';
import { tourConfig } from '../data/tour.config';

interface TourState {
  locale: Locale;
  currentSceneId: string | null;
  isTourStarted: boolean;
  isSceneListOpen: boolean;
  isToolbarVisible: boolean;
  isControlsVisible: boolean;
  isFullscreen: boolean;
  isGyroEnabled: boolean;
  isAutorotating: boolean;
  setLocale: (locale: Locale) => void;
  startTour: (sceneId?: string) => void;
  goToScene: (sceneId: string) => void;
  setSceneListOpen: (open: boolean) => void;
  toggleSceneList: () => void;
  setToolbarVisible: (visible: boolean) => void;
  toggleToolbar: () => void;
  setControlsVisible: (visible: boolean) => void;
  toggleControls: () => void;
  hideAllUi: () => void;
  showAllUi: () => void;
  setFullscreen: (value: boolean) => void;
  setGyroEnabled: (value: boolean) => void;
  setAutorotating: (value: boolean) => void;
  exitTour: () => void;
}

export const useTourStore = create<TourState>((set) => ({
  locale: 'vi',
  currentSceneId: tourConfig.defaultSceneId,
  isTourStarted: true,
  isSceneListOpen: false,
  isToolbarVisible: true,
  isControlsVisible: true,
  isFullscreen: false,
  isGyroEnabled: false,
  isAutorotating: false,
  setLocale: (locale) => set({ locale }),
  startTour: (sceneId) =>
    set({
      isTourStarted: true,
      currentSceneId: sceneId ?? tourConfig.defaultSceneId,
      isSceneListOpen: false,
    }),
  goToScene: (sceneId) =>
    set({
      currentSceneId: sceneId,
    }),
  setSceneListOpen: (open) => set({ isSceneListOpen: open }),
  toggleSceneList: () => set((s) => ({ isSceneListOpen: !s.isSceneListOpen })),
  setToolbarVisible: (visible) => set({ isToolbarVisible: visible }),
  toggleToolbar: () => set((s) => ({ isToolbarVisible: !s.isToolbarVisible })),
  setControlsVisible: (visible) => set({ isControlsVisible: visible }),
  toggleControls: () => set((s) => ({ isControlsVisible: !s.isControlsVisible })),
  hideAllUi: () =>
    set({
      isToolbarVisible: false,
      isSceneListOpen: false,
      isControlsVisible: false,
    }),
  showAllUi: () =>
    set({
      isToolbarVisible: true,
      isControlsVisible: true,
    }),
  setFullscreen: (value) => set({ isFullscreen: value }),
  setGyroEnabled: (value) => set({ isGyroEnabled: value }),
  setAutorotating: (value) => set({ isAutorotating: value }),
  exitTour: () =>
    set({
      isTourStarted: false,
      currentSceneId: null,
      isSceneListOpen: false,
      isToolbarVisible: true,
      isControlsVisible: true,
      isGyroEnabled: false,
    }),
}));
